import { FilterState } from '../../../../containers/applicant_tracking/Analytics/Filters';
import { RejectionBreakdown } from '../../../../entities/applicant_tracking/analytics/RejectionBreakdown';
import { ApiService } from '../../../ApiService';
import { mapToParams } from '../mapToParams';

export class RejectionBreakdownService {
  public static show(
    filterState?: FilterState,
    signal?: AbortSignal,
    groupBy?: string,
  ): Promise<RejectionBreakdown> {
    const params = {
      ...mapToParams(filterState),
      ...(groupBy != null && { group_by: groupBy }),
    };

    return ApiService.get(
      '/api/v1/applicant_tracking/analytics/rejection_breakdown',
      params,
      { signal },
    );
  }
}
